<template lang="pug">
  .component-backoffice-vehicle-slot-avaiability
    .time-slots(v-if="availability.length", :style="showRows")
      template.time-slots(v-for="(timeSlot, index) in availability" )
        label
          ToggleableButton.small(
            :key="timeSlot.start_timestamp",
            :disabled="!timeSlot.available",
            v-model="timeSlot.selected"
            :selectable="selectable",
            :style="{}"
            :class="{'fake-selection': fakeSelection(index)}"
            @click.native="checkIndex"
          ) {{formatUnix(timeSlot.end_timestamp)}}
        .grid-break(v-if="isStartOfDay(timeSlot.end_timestamp)")
          span {{timeBreak(timeSlot.end_timestamp)}}, {{$dateFormat(timeSlot.end,'DD MMM YYYY')}}
    .container
      .button-group
        .button(@click="loadMore") Load more
    .row.columns(v-if="selectable")
      slot
      button.button(
        :disabled="!selectionValid"
        :dark="selectionValid"
        @click="$emit('slotsSelected', selectedSlots)",
        :light="true"
      ) {{ selectionValid ? extend ? 'Extend ':'Book' : 'Select range'}}
</template>

<script type="text/babel">

  import Tooltip from 'components/structure/foundation/Tooltip'
  import ToggleableButton from '../structure/ui/ToggleableButton'
  import moment from 'moment'

  export default {
    name: 'BackofficeVehicleAvailability',
    data() {
      return {
        selectionStart: -1,
        selectionEnd: -1,
        rows: 1
      }
    },
    components: {
      ToggleableButton,
      Tooltip
    },
    props: {
      type: {
        type: String,
        default: ''
      },
      availability: {
        type: Array,
        default: () => []
      },
      selectable: {
        type: Boolean,
        default: true
      },
      extend: {
        type: Boolean,
        default: false
      }
    },
    created() {

    },
    methods: {
      loadMore() {
        this.resetSelection()
        this.$emit('loadExtra')
        this.rows++
      },

      fakeSelection(index) {
        if (this.selectionStart >= 0 && this.selectionEnd >= 0) {
          return index <= this.selectionEnd && index > this.selectionStart - 1
        }
      },
      setSelections() {

        this.selectionStart = this.availability.findIndex((timeslot) => {
          return timeslot.selected
        })

        const reverse = this.availability.reduce((arr, el) => {
          arr.unshift(el)
          return arr
        }, [])

        this.selectionEnd = this.selectionStart >= 0 ? Math.abs(reverse.findIndex((timeslot) => {
          return timeslot.selected
        }) - reverse.length + 1) : -1
        this.$emit('rangeSelection', this.selectedSlots )
        return this.selectionStart !== -1 && this.selectionEnd !== -1
      },
      checkIndex() {

        if (!this.selectable) {
          return
        }
        const thereAreSelections = this.setSelections()

        if (this.extend && thereAreSelections) {
          this.selectionStart = 0
        }

        if (this.selectionStart + this.selectionEnd !== -2) {

          if (this.selectionStart !== this.selectionEnd) {
            this.toggleSelection(this.selectionStart)
            this.toggleSelection(this.selectionEnd)
          }
        }
        if (this.selectionCrossesUnavailable == true) {
          this.resetSelection()
        }

      },
      toggleSelection(index) {
        if ( this.availability && index < this.availability.length && index >= 0)
        this.availability[index].selected = false
      },
      resetSelection() {
        this.toggleSelection(this.selectionStart)
        this.toggleSelection(this.selectionEnd)
        this.setSelections()
      },
      formatUnix(t) {
        return moment.unix(t).format('HH:mm')
      },
      timeBreak(t) {
        return moment.unix(t).calendar(undefined, {
          lastDay: '[Yesterday]',
          sameDay: '[Today]',
          nextDay: `[Tomorrow]`,
          lastWeek: '[last] dddd',
          nextWeek: 'dddd',
          sameElse: 'L',
        })
      },
      isStartOfDay(t) {
        return t === moment.unix(t).startOf('day').unix()
      }
    },
    computed: {
      selectionCrossesUnavailable() {
        for (let i = this.selectionStart; i < this.selectionEnd; i++) {
          if (this.availability[i].available === false) {
            return true
          }
        }
        return false
      },
      selectedSlots() {
        return {
          start: this.selectionStart >= 0 ? this.availability[this.selectionStart].start_timestamp : null,
          end: this.selectionEnd >= 0 ? this.availability[this.selectionEnd].end_timestamp : null,
        }
      },
      selectionValid() {
        const notEqual = this.selectionStart !== this.selectionEnd || this.extend
        const notStartSelection = this.selectionStart + this.selectionEnd !== -2
        return notEqual && notStartSelection && !this.selectionCrossesUnavailable
      },
      showRows() {
        return {
          // gridTemplateRows: `repeat(${this.rows * 5}, min-content)`
        }
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-vehicle-slot-avaiability
    .time-slots
      display: grid
      grid-template-columns: repeat(auto-fill, minmax(5em, 1fr))
      /*grid-auto-rows: 0*/
      border-bottom: 1px solid #cacaca

      &.show-5
        grid-template-rows: repeat(5, min-content)

      .grid-break
        grid-column: 1/-1
        text-align: center
        overflow: hidden
        display: flex

        span
          height: .75* 2em
          text-transform: capitalize
          margin: .25* 2em auto .5* 2em

      label
        overflow: hidden

        .toggleable-button
          &.fake-selection
            button
              background-color: green !important
              color: white !important

    .layout
      display: flex
      justify-content: space-between

    .box-wrapper
      div
        display: inline-block
        margin: 2px

      .box
        cursor: pointer
        height: auto
        width: auto
        background-color: black
        padding: 10px

      .bg-green
        background-color: #3adb76
        color: #ffffff

      .bg-red
        background-color: #be2626
</style>



// WEBPACK FOOTER //
// VehicleAvailability.vue?7b274f71